/**
 * 체크리스트 진입 시설 id 판정.
 *
 * 영구지침: docs/develop/seo/ssr-spec.md §17.2.2
 *
 * 시설 상세의 체크리스트 카드는 `/checklist?facilityId={id}` 대신 `/checklist` + router state
 * `{ facilityId }` 로 링크한다(크롤러가 볼 고유 URL 0개, §17.2.1). 이미 퍼진 옛 쿼리 링크는
 * 하위 호환으로 계속 읽는다.
 *
 * 순수 함수(`@/` 별칭 import 없음) — `npm test`(tsx --test)로 단독 실행된다.
 */

function toPositiveInt(value: unknown): number | null {
  if (typeof value === 'number') {
    return Number.isInteger(value) && value > 0 ? value : null
  }
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (trimmed === '') return null
    const n = Number(trimmed)
    return Number.isInteger(n) && n > 0 ? n : null
  }
  return null
}

/** 체크리스트 진입 시설 id — router state 우선, 없으면 옛 쿼리(?facilityId=) */
export function resolveEntryFacilityId(state: unknown, search: string): number | null {
  if (state !== null && typeof state === 'object' && !Array.isArray(state)) {
    const fromState = toPositiveInt((state as { facilityId?: unknown }).facilityId)
    if (fromState != null) return fromState
  }
  const fromQuery = toPositiveInt(new URLSearchParams(search).get('facilityId'))
  return fromQuery
}
